export default "__VITE_ASSET__CI5Cg$2N__"